<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat style="border-bottom: solid 1px orange !important;">
        <v-card-text class="pa-0">
          <v-layout row wrap pa-2 style="border-bottom: solid 1px orange;">
            <v-flex xs12 md6 pt-2>
              <h2 class="headline">{{ member.details.firstName }} {{ member.details.lastName }}</h2>
            </v-flex>
            <v-spacer/>
            <v-flex xs12 md6 text-xs-right>
              <span v-if="sendYes" class="green--text subheading" style="vertical-align: sub">Email Sent!</span>
              <span v-if="sendNo" class="red--text subheading" style="vertical-align: sub">No Action Taken!</span>
              <v-btn :loading="resetLoading" flat outline small class="ml-3 mb-1 pt-0" @click="resetUserPwd()">Resend Activation Email</v-btn>
              <v-btn flat outline small class="ml-3 mb-1 pt-0" @click="gotoMember()">View Profile</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap pa-2>
            <v-flex xs12 md2>
              <p class="small ma-0">Account Created: {{formatDate(member.accountCreated, 'since')}}</p>
              <p class="small ma-0">Last Activation Email Sent: {{formatDate(member.activationSend)}}</p>
            </v-flex>
          </v-layout>
          <v-layout row wrap pa-2>
            <v-flex xs12 md4 pa-0 pr-2>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3>Contact Information</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 pr-2 v-if="member.details.phoneNumber">
                    <v-text-field
                      readonly
                      label="Phone Number"
                      :value="member.details.phoneNumber"
                    />
                  </v-flex>
                  <v-flex xs12 md6 v-if="member.details.mobileNumber">
                    <v-text-field
                      readonly
                      label="Mobile Number"
                      :value="member.details.mobileNumber"
                    />
                  </v-flex>
                  <v-flex xs12 v-if="member.details.address">
                    <v-text-field
                      readonly
                      label="Address"
                      :value="generateAddressString(member.details)"
                    />
                  </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md4 pl-2>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3>Membership Information</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="member.membership.current !== null">
                  <v-flex xs12 md6 pr-2>
                    <v-text-field
                      readonly
                      label="Membership Type"
                      :value="(member.membership.type === 'life') ? 'Life Member': 'General Member'"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      readonly
                      label="Member Since"
                      placeholder=""
                      :value="formatDate(member.membership.memberSince, 'since')"
                    />
                  </v-flex>
                  <v-flex xs12 md6 pr-2>
                    <v-text-field
                      readonly
                      label="Activated On"
                      :value="formatDate(member.membership.current.subscriptionStarts)"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      readonly
                      label="Renewal Payment Due"
                      :value="formatDate(member.membership.current.subscriptionEnds)"
                    />
                  </v-flex>
                </v-layout>
                <v-layout v-else row wrap>
                  <v-flex xs12>
                    <p>No Active Membership</p>
                  </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md4 pl-2>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Club Involvement</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="(!member.committee || !member.committee.active) && (!member.executive || !member.executive.active)">
                <v-flex xs12>
                  <p class="small">No Involvement</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="member.committee && member.committee.active">
                <v-flex xs12 md6 pr-2>
                  <v-text-field
                    readonly
                    label="Group"
                    value="General Committee"
                  />
                </v-flex>
                  <v-flex xs12 md6>
                  <v-text-field
                    readonly
                    label="Joined"
                    :value="formatDate(member.committee.since)"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="member.executive && member.executive.active">
                <v-flex xs12 md6 pr-2>
                  <v-text-field
                    readonly
                    label="Group"
                    value="Executive Board"
                  />
                </v-flex>
                  <v-flex xs12 md6>
                  <v-text-field
                    readonly
                    label="Joined"
                    :value="formatDate(member.executive.since)"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md4 v-if="member.details.secondary">
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Secondary Contact</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 pr-2>
                  <v-text-field
                    readonly
                    label="Contact Number"
                    :value="member.details.secondary.number"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    readonly
                    label="Contact Name"
                    :value="member.details.secondary.name"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    member: Object
  },
  data () {
    return {
      resetLoading: false,
      sendYes: false,
      sendNo: false
    }
  },
  methods: {
    ...mapActions([
      'resendAccountActivation'
    ]),
    formatDate (timestring, type = null) {
      if (!timestring) return '-'
      let time = new Date(timestring)
      switch (type) {
        case 'full':
          return `${this.days[time.getDay()]}, ${time.getDate()} ${this.months[time.getMonth()]} ${time.getFullYear()}`
        case 'since':
          let newFormat = `${time.getDate()}/${time.getMonth() + 1}/${time.getFullYear()}`
          let nowYear = new Date().getFullYear()
          let yearDiff = nowYear - time.getFullYear()

          if (yearDiff === 0) return newFormat
          if (yearDiff === 1) return newFormat + ' (1 Year)'
          return newFormat + ` (${yearDiff} Years)`
        default:
          return `${time.getDate()}/${time.getMonth()}/${time.getFullYear()}`
      }
    },
    async resetUserPwd () {
      try {
        console.log('Resending Account Acitvation Email...')
        if (this.resetLoading) return false
        this.resetLoading = true
        const args = {
          userid: this.member.id
        }

        console.log('Reset User Pwd: ', args)

        let response = await this.resendAccountActivation(args)
        console.log(response)
        this.resetLoading = false
        if (response.error !== undefined) {
          alert(response.error.message)
          return false
        }

        if (response.resetUsers && response.resetUsers.length > 0 && response.resetUsers[0] !== null) {
          console.log('reset successful')
          this.member.activationStatus = response.resetUsers[0].activationStatus
          this.$emit('updateUser', { id: this.member.id, update: response.resetUsers[0] })
          this.sendYes = true
          setTimeout(() => (this.sendYes = false), 1000)
        } else {
          console.log('account active; no action taken')
          this.sendNo = true
          setTimeout(() => (this.sendNo = false), 1000)
        }

        this.resetModal = false
        return true
      } catch (e) {
        this.resetLoading = false
        alert(e.message)
        return false
      }
    },
    generateAddressString: function (details) {
      return `${details.address.street} ${details.address.suburb} ${details.address.postcode} ${details.address.state}`
    },
    gotoMember () {
      // window.open('http://localhost:8080/#/admin/members/'+this.member.id, '_blank');
      this.$emit('viewMember', this.member.id)
    },
    membershipPaymentPrice (membership) {
      if (membership.type !== 'life' && membership.type !== 'sponsor') {
        const price = membership.current.price
        if (price !== 0 && price !== '0') return price
      }

      return ''
    }
  }
}

</script>
